import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[rqaPhoneNumber]',
  standalone: true
})
export class PhoneNumberDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const initialValue = input.value;

    let newValue = initialValue.replace(/[^\d+]/g, '');

    if (newValue.includes('+') && !newValue.startsWith('+') && !newValue.endsWith('+')) {
      newValue = newValue.replace(/\+/g, '');
    }

    const plusCount = (newValue.match(/\+/g) || []).length;

    if (plusCount > 1) {
      newValue = newValue.replace(/\+/g, '') + '+';
    }

    input.value = newValue;

    if (initialValue !== input.value) {
      event.stopPropagation();
    }
  }
}
